/**
 * LocationAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LocationAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.91 23.191v-2q-3.142-.355-5.422-2.641t-2.63-5.41h-2v-2.18h2Q3.215 7.818 5.5 5.538t5.41-2.63v-2h2.18v2q3.125.35 5.41 2.63t2.641 5.422h2v2.18h-2q-.35 3.124-2.629 5.41t-5.422 2.641v2zM12 18.978q2.875 0 4.902-2.026 2.026-2.026 2.026-4.902t-2.026-4.902T12 5.122q-2.875 0-4.902 2.026-2.025 2.026-2.026 4.902t2.026 4.902Q9.124 18.978 12 18.978" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LocationAltIcon = makeIcon('LocationAltIcon', LocationAltIconSvg)
